export default function({ dispatch, commit }, verification) {
    commit('startedAuthentication')

    // POST /auth/login
    return dispatch('post', {
        url: '/auth/verify/email',
        data: verification
    }, {
        root: true
    })
    .then((response) => {
        commit('finishedAuthentication')
        commit('validatedEmail', verification.email)
        return response
    })
    .catch((error) => {
        commit('finishedAuthentication')
        throw error
    })
}
